import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const ErrorCircleSolidIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('ErrorCircleSolidIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      fillRule="evenodd"
      d="M.5 8a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0M8 4.86c.385 0 .698.313.698.698v2.79a.698.698 0 1 1-1.396 0v-2.79c0-.385.313-.698.698-.698m0 4.884a.698.698 0 1 0 0 1.396h.006a.698.698 0 1 0 0-1.396z"
      clipRule="evenodd"
    />
  </svg>
);
ErrorCircleSolidIcon.id = 'ErrorCircleSolidIcon';
ErrorCircleSolidIcon.displayName = 'ErrorCircleSolidIcon';
export default ErrorCircleSolidIcon;
